import { render, staticRenderFns } from "./VehicleManagement.vue?vue&type=template&id=b1e513d8&scoped=true"
import script from "./VehicleManagement.vue?vue&type=script&lang=js"
export * from "./VehicleManagement.vue?vue&type=script&lang=js"
import style0 from "./VehicleManagement.vue?vue&type=style&index=0&id=b1e513d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e513d8",
  null
  
)

export default component.exports